import { Box, Typography } from '@mui/material';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { getSubjectWiseFreeSlotHistory } from '../../../../redux/features/CRDslice';
import SimpleLoader from '../../../../components/Loader/SimpleLoader';

export default function PreviousMonthHistory({ row }) {
  const subjectWiseFreeSlotHistoryLoading = useSelector((state) => state.crd.subjectWiseFreeSlotHistory.loading);
  const subjectWiseFreeSlotHistory = useSelector((state) => state.crd.subjectWiseFreeSlotHistory.data);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getSubjectWiseFreeSlotHistory(row?.subject_id));
  }, [row, dispatch]);
  return (
    <Box bgcolor={'#F5F5F5'} p={2} borderRadius={2} gap={1} display={'flex'} flexDirection={'column'}>
      {subjectWiseFreeSlotHistoryLoading ? (
        <SimpleLoader />
      ) : (
        subjectWiseFreeSlotHistory?.map((e, i) => (
          <Box display={'flex'} justifyContent={'space-between'} key={i}>
            <Typography>
              <span style={{ fontWeight: 800, fontSize: '1rem' }}> {e.month_name?.split(' ')?.[0]}</span>
              {' - '}
              <span style={{ color: 'gray', fontSize: '0.8rem' }}>{e.month_name?.split(' ')?.[1]}</span> :
            </Typography>
            <Typography>{e.utilized_slots}</Typography>
          </Box>
        ))
      )}
    </Box>
  );
}
